<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@roles-changed='reloadOrganizationsPanel')
</template>

<script>
export default {
  name: 'manager-organizations-roles',
  methods: {
    reloadOrganizationsPanel() {
      this.$parent.$refs.organizationsPanel.panelReload()
    },
  },
}
</script>
